/* The buy bar competes with the hero's own call to action and eats the bottom of
   the fold, so it stays tucked away until the reader has scrolled past the hero.
   Written so that without JavaScript nothing changes: the bar is visible by
   default and only this file ever hides it. */
(function () {
  var bar = document.querySelector('.bar');
  var hero = document.querySelector('.hero');
  if (!bar || !hero || !('IntersectionObserver' in window)) return;

  // The hero is on screen at load, so start tucked rather than flashing the bar.
  bar.classList.add('bar--tucked');

  new IntersectionObserver(function (entries) {
    bar.classList.toggle('bar--tucked', entries[0].isIntersecting);
  }, { threshold: 0 }).observe(hero);
})();
